import React, { Component } from 'react'

import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'

import Icon from '@material-ui/core/Icon'
import { localize } from '../../util/Localizer'
import BenefitCard from '../../components/BenefitCard'
import PrintBenefitStatement from './PrintBenefitStatement'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { withStyles } from '@material-ui/core'

import RBButton from '../../controls/RBButton'
import { Fonts, Colors } from '../../theme'

import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import browser from 'detect-browser'

class QuickLinks extends Component {
  constructor (props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this)
    this.handleRequestClose = this.handleRequestClose.bind(this)
    this.printClaims = this.printClaims.bind(this)
    this.printBenfitCard = this.printBenfitCard.bind(this)
    this.state = {
      open: false,
      snackOpen: false,
      snackStatementOpen: false,
      snackClaimsOpen: false,
      openDialog: false
    }
  }

  handleTouchTap (e) {
    e.preventDefault()
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    })
  };

  handleRequestClose () {
    this.setState({
      open: false,
      snackOpen: false,
      snackStatementOpen: false,
      snackClaimsOpen: false
    })
  }

  printClaims () {
    const p = this.props
    const totalClaims = p.pageSize < p.totalClaims ? p.pageSize : p.totalClaims
    const windowFeatures = browser.name === 'ie' ? 'scrollbars=yes,height=860,width=600' : 'height=400,width=600'
    let mywindow = window.open('', 'PRINT', windowFeatures)

    mywindow.document.write('<html><head><title>' + document.title + '</title>')
    mywindow.document.write(`<style>p{font-size:1rem; font-family: ${Fonts.primaryFontFamily}}.header{width:100%; text-align:center; font-size:10px}.logo{width:100%}.logo img{width:120px; display:block; margin:auto !important}.inlineBlock{display:none}.summaryCard{border-top:2px solid ${Colors.Palette.blackColor}; margin-top:3px; box-shadow:none !important}div div{float:left}.summaryHeader .titledLabelTitle{font-size:14px} .row div{margin:0px 3px}.titledLabelTitle{font-weight:bold; font-size:12px}.titledLabelLabel{font-weight:300}.approved, .approuvé{color: ${Colors.Palette.successColor}}.pending, .attente{color: ${Colors.Palette.warningColor}}.rejected, .rejeté{color: ${Colors.Palette.errorColor}}.declined, .annulée{color: ${Colors.Palette.errorColor}}</style>`)
    mywindow.document.write('</head><body ><div class="logo"><img src="img/logo_en.svg"/> ')
    mywindow.document.write(`<div class="header"><p>${localize('common.printclaims.total')}: ${totalClaims}</p> </div> `)
    mywindow.document.write('<div class="printing clearfix">')
    mywindow.document.write(document.getElementById('claimSummary').innerHTML)
    mywindow.document.write('</div></body></html>')

    mywindow.document.close() // necessary for IE >= 10
    mywindow.focus() // necessary for IE >= 10*/

    mywindow.print()
    mywindow.close()

    // close the popover
    this.setState({ open: false })
  }

  printBenfitCard () {
    let benfitCardHtml = {}
    if (!document.getElementById('benefitCardContent')) {
      benfitCardHtml = 'error'
    } else {
      benfitCardHtml = document.getElementById('benefitCardContent').innerHTML
    }
    if (benfitCardHtml === 'error') {
      this.setState({ openDialog: true })
    } else {
      // const benfitCardHtml = document.getElementById('benefitCardContent').innerHTML
      const windowFeatures = browser.name === 'ie' ? 'scrollbars=yes,height=860,width=600' : 'height=400,width=600'
      let mywindow = window.open('', 'PRINT', windowFeatures)
      mywindow.document.write('<html><head>')
      mywindow.document.write(`<style>table tr td:empty {width: 75px;}table tr th {padding:3px 10px;}table tr td {padding:3px 10px;}p{font-size:1rem; font-family: ${Fonts.primaryFontFamily}}.header{width:100%; text-align:center; font-size:10px}.logo{width:100%}.logo img{width:120px; display:block; margin:auto !important}.inlineBlock{display:none}</style>`)
      mywindow.document.write('</head><body > ')
      mywindow.document.write('<div class="printing clearfix">')
      mywindow.document.write(benfitCardHtml)
      mywindow.document.write('</div></body></html>')

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/
      setTimeout(function () { // to fix - logo disappears on second time print
        mywindow.print()
        mywindow.close()
      }, 500)
    }

    // close the popover
    this.setState({ open: false })
  }

  render () {
    const {
      isLoading
    } = this.props

    return (
      <div>
        <Dialog
          open={this.state.openDialog}
          style={{ textAlign: 'center' }}
        >
          <DialogTitle>{localize('print.benefitCard.error.title')}</DialogTitle>
          <DialogContent>{localize('print.benefitCard.error.subTitle')}</DialogContent>
        </Dialog>
        <RBButton
          className={this.props.classes.quickLinksButton}
          label={localize('common.header.quickLinks')}
          primary={false}
          variant='outlined'
          onClick={this.handleTouchTap}
          labelPosition='before'
          icon={<Icon color="primary">arrow_drop_down</Icon>}
          onLoad={this.showPrintCLaims}
        />
        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
        >
          <MenuItem onClick={this.printBenfitCard} >{isLoading ? localize('common.loadingContent') : localize('common.header.printCard')}</MenuItem>
          <PrintBenefitStatement />
          {this.props.showPrintClaims ? <MenuItem onClick={this.printClaims} id='printClaims' >{localize('common.header.printClaims')}</MenuItem> : null}
        </Menu>
        <BenefitCard />
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    pageNum: state.ClaimsReducer.pageNum,
    totalPages: state.ClaimsReducer.totalPages,
    pageSize: state.ClaimsReducer.pageSize,
    totalClaims: state.ClaimsReducer.totalClaims,
    isLoading: state.BenefitCardReducer.isLoading
  }
}

const ConnectedQuickLinks = connect(mapStateToProps, {})(injectIntl(QuickLinks))

const styles = {
  quickLinksButton: {
    minWidth: 186
  }
}

export default withStyles(styles)(ConnectedQuickLinks)



// WEBPACK FOOTER //
// ./src/widgets/common/quickLinks.js